// removed by extract-text-webpack-plugin
module.exports = {"toggle":"Toggle-m__toggle___1Fmxp","toggleWrapper":"Toggle-m__toggleWrapper___38jt3","toggleInput":"Toggle-m__toggleInput___X1ZOm","toggleLabel":"Toggle-m__toggleLabel___RMW3b","toggleLabelText":"Toggle-m__toggleLabelText___380pG","toggleHighlight":"Toggle-m__toggleHighlight___1xi3X","toggleHighlightInner":"Toggle-m__toggleHighlightInner___3nHWk","small":"Toggle-m__small___1rUyl"};


//////////////////
// WEBPACK FOOTER
// ./components/toggle/Toggle.m.sass
// module id = 5CV1
// module chunks = 0